<template>
  <div class="row mx-0 px-3 py-4 d-flex">
    <label class="size-12" for="">利用サービス</label>
    <div class="d-flex border-bottom">
      <component :is="currentPlatformComponent" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useBaseInformationStore } from '@/stores/resume-candidate/BasicInformation.store';
import { PLATFORM_TYPE } from '@/utils/constants';
import PlatformDirect from './PlatformDirect.vue';
import PlatformAgent from './PlatformAgent.vue';
import PlatformBoth from './PlatformBoth.vue';

const baseInformationStore = useBaseInformationStore();

const currentPlatformComponent = computed(() => {
  const platform = baseInformationStore.platform;

  if (platform.includes(PLATFORM_TYPE.AGENT) && platform.includes(PLATFORM_TYPE.DIRECT)) {
    return PlatformBoth;
  } else if (platform.includes(PLATFORM_TYPE.AGENT)) {
    return PlatformAgent;
  } else if (platform.includes(PLATFORM_TYPE.DIRECT)) {
    return PlatformDirect;
  }
  return null;
});
</script>
